import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConceptoFoto, FotografiaError } from 'src/app/models/complementos-web/complementos-web.model';
import { DocumentumStoreFileDetailsIntern } from 'src/app/models/documentum/documentum.model';
import { DragDropMultipleFileDirective } from '../../@directives/drag-drop-multiple.directive';


export interface FotoError {
  archivo: File;
  valido: boolean;
  errores: FotografiaError[]
}

export interface DropFile {
  nombre: string;
  fotografia: string;
  base64: any;
  mime: string;
  progress: number;
  id: number
  rowid: number
  estatus: number
  size: number
}

@Component({
    selector: 'app-drag-drop-multiple-complemento',
    templateUrl: './drag-drop-multiple-complemento.component.html',
    styleUrls: ['./drag-drop-multiple-complemento.component.scss'],
    imports: [DragDropMultipleFileDirective]
})
export class DragDropMultipleComplementoComponent {

  @Input() inMultiple: boolean = true;
  @Input() inFormatos: string = '.pdf';
  @Input() infoArchivo: ConceptoFoto;
  @Input() inDisabled: boolean = false;

  @Output() eventosDragDrop = new EventEmitter<{ nombre: string, valor: any }>();
  @Output() archivosValidados = new EventEmitter<DocumentumStoreFileDetailsIntern[]>();
  @Output() archivosRechazados = new EventEmitter<FotoError[]>();

  public progress: number = 0;
  public spinnerRotation: number = 0;
  public fillOpacity: number = 0;
  public maskOpacity: number = 1;
  public listFiles: DropFile[] = [];
  public totalFiles = 0;
  public nombreArchivo: any;
  public idArchivo: any;
  public documentLoading: DropFile | null = null;

  constructor(
  ) { }

  ngOnInit(): void {
  }

  /**
   * on file drop handler
   */
  onFileDropped($event) {
    console.log($event)
    this.procesarArchivos($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files: any) {
    const archivos = files.target.files;
    this.procesarArchivos(archivos);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(id: number) {
    // console.log(id)
    this.listFiles = this.listFiles.filter(item => item.id !== id);
    // this.fileLoading.set(null);
    this.progress = 0;
    this.spinnerRotation = 0;
    this.fillOpacity = 0;
    this.maskOpacity = 1;
    this.eventosDragDrop.emit({ nombre: 'eliminar-archivos', valor: this.listFiles });
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.listFiles.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          let file: any = this.listFiles[index];
          // console.log(file)
          // this.fileLoading.set(file);
          this.documentLoading = file;
          if (file?.progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            file.progress = file.progress + 10;
            this.progress = file.progress;
            this.updateProgress();
            console.log(this.progress)
            let filesModified: any[] = this.listFiles.map((item, idx) => {
              return file.id === item.id ? file : item
            });
            this.listFiles = filesModified;
          }
        }, 10);
      }
    }, 50);
  }

  updateProgress() {
    if (this.progress < 0 || this.progress > 100) {
      this.progress = 0;
    }
    this.eventosDragDrop.emit({ nombre: 'progreso-archivos', valor: this.progress });

    const deg = this.progress * 3.6;

    if (this.progress > 50) {
      this.fillOpacity = 1;
      this.maskOpacity = 0;
    } else {
      this.fillOpacity = 0;
      this.maskOpacity = 1;
    }

    this.spinnerRotation = deg;
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    for (const item of files) {

      const reader = new FileReader();

      reader.onload = (event => {
        const fileParse = item;
        const fullBase64: string | ArrayBuffer | null = reader.result;
        const b64 = (fullBase64 as string).split(",")[1];
        const fulltipoMime = (event.target?.result as String).split(';')[0];
        const tipoMimeDoc = (event.target?.result as String).split(';')[0].split('/')[1];

        const fileLoaded: DropFile = {
          nombre: fileParse.name,
          rowid: 0,
          estatus: 0,
          fotografia: b64,
          base64: fullBase64,
          mime: fulltipoMime,
          progress: 0,
          size: fileParse.size,
          id: Math.round(Math.random() * new Date().getTime() * 0.0012)
        }
        this.nombreArchivo = fileParse.name;
        this.idArchivo = fileLoaded?.id
        this.listFiles = [...this.listFiles, fileLoaded]
      });

      reader.readAsDataURL(item);

      reader.onerror = ((e) => {
        this.eventosDragDrop.emit({ nombre: 'error-archivos', valor: this.listFiles });
      });
      reader.onloadend = ((e) => {
        if (this.nombreArchivo.split('.')[1]) {
          this.eventosDragDrop.emit({ nombre: 'carga-lista-archivos', valor: this.listFiles });
        }
      });

    }
    this.uploadFilesSimulator(0);
  }

  async procesarArchivos(fileList: FileList): Promise<void> {
    const archivosValidados: DocumentumStoreFileDetailsIntern[] = [];
    const archivosRechazados: FotoError[] = [];

    for (const file of Array.from(fileList)) {
      const valido = this.validacionesFotografias(file);
      if (valido.valido == false) {
        archivosRechazados.push({ archivo: file, valido: valido.valido, errores: valido.errores });
        continue;
      }

      try {
        const contenidoBase64 = await this.leerArchivoComoBase64(file);
        archivosValidados.push({
          documentName: file.name,
          subject: file.name,
          title: file.name,
          storagePath: "/atlas/expgnrl02/ComplementoWeb",
          objectId: null,
          link: '',
          documentalType: "atlas_expgnrl02",
          siniestro: "",
          size: contenidoBase64.size.toString(),
          contentType: contenidoBase64.mime,
          base64: contenidoBase64.fotografia,
          fullBase64: contenidoBase64.base64,
        });
      } catch (error) {
        archivosRechazados.push({ archivo: file, valido: false, errores: [{ nombre: file.name, error: 'Error al leer el archivo' }] });
      }
    }

    if (archivosValidados.length) {
      this.archivosValidados.emit(archivosValidados);
    }

    if (archivosRechazados.length) {
      this.archivosRechazados.emit(archivosRechazados);
    }
  }

  private leerArchivoComoBase64(file: File): Promise<DropFile> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = ((event) => {
        const fullBase64: string | ArrayBuffer | null = reader.result;
        const b64 = (fullBase64 as string).split(",")[1];
        const fulltipoMime = (event.target?.result as String).split(';')[0];
        const fileLoaded: DropFile = {
          nombre: file.name,
          rowid: 0,
          estatus: 0,
          fotografia: b64,
          base64: fullBase64,
          mime: fulltipoMime,
          progress: 0,
          size: file.size,
          id: Math.round(Math.random() * new Date().getTime() * 0.0012)
        }
        resolve(fileLoaded);
      });
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(file);
    });
  }

  validacionesFotografias(file: File): { valido: boolean; errores: FotografiaError[] } {
    const extensionesPermitidas = this.infoArchivo.tipo_archivo.split(',').map(ext => ext.trim().toUpperCase());
    const extensionArchivo = file.name.substring(file.name.lastIndexOf('.')).toUpperCase();
    const tamañoKb = file.size / 1024;

    const listaErrores: FotografiaError[] = [];
    const fotografiasActuales = this.infoArchivo.Todo;

    // 1. Validar si ya existe el archivo (por nombre)
    const yaExiste = fotografiasActuales.some(foto => foto.nombre == file.name);
    if (yaExiste) {
      listaErrores.push({ nombre: file.name, error: 'Ya existe una fotografía con el mismo nombre' });
      return { valido: false, errores: listaErrores };
    }

    // 2. Validar extensión
    if (!extensionesPermitidas.includes(extensionArchivo)) {
      listaErrores.push({ nombre: file.name, error: 'Extensión no válida' });
      return { valido: false, errores: listaErrores };
    }

    // 3. Validar tamaño
    if (tamañoKb > this.infoArchivo.tam_maxkb) {
      const tamanoTexto = this.formatSize(this.infoArchivo.tam_maxkb);
      listaErrores.push({ nombre: file.name, error: `Tamaño no válido. El limite permitido ${tamanoTexto}` });
      return { valido: false, errores: listaErrores };
    }

    return { valido: true, errores: listaErrores };
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  formatSize(kb: number): string {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let bytes = kb * 1024; // Convertimos KB a Bytes
    let unitIndex = 0;

    while (bytes >= 1024 && unitIndex < sizes.length - 1) {
      bytes /= 1024;
      unitIndex++;
    }

    return `${bytes.toFixed(2)} ${sizes[unitIndex]}`;
  }
}
